import { BaseConfig } from '../ServiceConfig';

export interface SalePortalBffConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.SalePortalBffServiceConfigData';
  url: string;
}

export const SalePortalBffConfigurationFields: (keyof SalePortalBffConfiguration)[] = [
  'url',
];

export const BlankSalePortalBffConfiguration: SalePortalBffConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.SalePortalBffServiceConfigData',
} as SalePortalBffConfiguration;
